







import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import { UserPermission } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import EmployerPricing from "./EmployerPricing.vue";
import EmployerInvestmentSettings from "./EmployerInvestmentSettings.vue";

@Component({
  components: {
    EmployerPricing,
    EmployerInvestmentSettings
  }
})
export default class EmployerBilling extends Vue {
  @Prop() employerId: number;

  featureFlagStore = useFeatureFlagStore();
  rolePermissions = useRolePermissionsStore();

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
      ? this.rolePermissions.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
      : true;
  }
}
